import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = 'tag';

export type tagsType = {
    tag_name: string;
}

export type tagsList = {
    keyword?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    page?: number;
    sortBy?: string;
    sortType?: string;
}
export class TagsApi extends BaseAPI {
    static list(query: tagsList): Promise<AxiosResponse> {
        return this.api.get(`${path}`, { params: { ...query } })
    }
    static create(body: tagsType): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_tag: number, body: tagsType): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_tag}`, body)
    }
    static delete(id_tag: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_tag}`)
    }
    static findOne(id_tag: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_tag}`)
    }
}